export enum OrderType {
  inventory = 0, // 在庫販売
  preorder = 1, // プレオーダー
}

export const ORDER_TYPE_LABEL: Record<OrderType, string> = {
  [OrderType.inventory]: '在庫',
  [OrderType.preorder]: '予約販売',
};
